var stores = ['','kaufland','carrefourhypermarket','cora','auchan','megaimage','carrefourmarket'],

	storeNames = ['','Kaufland','Carrefour','Cora','Auchan','Mega Image','Carrefour Market'],

	pageTitles = ['Alege magazinul și înscrie bonul:','<span>Câștigă premii pentru momentele <span class="visible-xs-inline visible-sm-block visible-md-block visible-lg-block">petrecute alături de prietenii tăi!</span></span>','Înscrie aici datele bonului tău:','Câștigători',''],

	buyText =
		['',
			'<div class="ziuareintalnirii-step-line">produse Bergenbier</div><div class="ziuareintalnirii-step-line">în valoare de</div><div class="ziuareintalnirii-step-line">minimum 12 lei</div>',
			'<div class="ziuareintalnirii-step-line">produse Bergenbier</div><div class="ziuareintalnirii-step-line">în valoare de</div><div class="ziuareintalnirii-step-line">minimum 12 lei</div>',
			'<div class="ziuareintalnirii-step-line">orice produs</div><div class="ziuareintalnirii-step-line">Bergenbier</div>',
			'<div class="ziuareintalnirii-step-line">orice produs</div><div class="ziuareintalnirii-step-line">Bergenbier</div>',
			'<div class="ziuareintalnirii-step-line">orice produs</div><div class="ziuareintalnirii-step-line">Bergenbier</div>',
			'<div class="ziuareintalnirii-step-line">orice produs</div><div class="ziuareintalnirii-step-line">Bergenbier</div>'
		],

	startDates = ['','01/06/2020','08/06/2020','01/06/2020','17/06/2020','04/06/2020','01/06/2020'],
	endDates = ['','30/06/2020','07/07/2020','30/06/2020','14/07/2020','02/07/2020','30/06/2020'],
	/*startDates = ['','01/05/2020','08/05/2020','01/05/2020','17/04/2020','04/05/2020','01/06/2020'],
	endDates = ['','30/06/2020','07/07/2020','30/06/2020','14/04/2020','02/07/2020','30/06/2020'],*/
	activeStore, maxHeight = $('#zr-1').outerHeight(),

	messages = ['',
				'1 Iunie - 30 Iunie 2020',
				'8 Iunie - 7 Iulie 2020',
				'1 Iunie - 30 Iunie 2020',
				'17 Iunie - 14 Iulie 2020',
				'4 Iunie - 2 Iulie 2020',
				'1 Iunie - 30 Iunie 2020'
			   ];

$(window).load(function() {

	if (!window.matchMedia("(max-width: 767px)").matches) {
		//console.log(maxHeight);
		$('#zr-store').show();
		$('#prizes-desktop').attr('src','/themes/bergenbier/img/ziuareintalnirii/premii-desktop-1.png');
		maxHeight = $('#zr-store').outerHeight() > $('#zr-1').outerHeight() ? $('#zr-store').outerHeight() : $('#zr-1').outerHeight();
		$('#zr-store').removeAttr('style');
		$('#prizes-desktop').attr('src','');
		$('.ziuareintalnirii-box-content').css({'min-height':maxHeight+'px'});
	}

	if ($('.ziuareintalnirii-box').data('store')){
		$(".ziuareintalnirii-magazine").find('a[data-store="'+$('.ziuareintalnirii-box').data('store')+'"]').trigger('click');
	}

	TweenMax.to($('.preloader'), .5, {
		delay: 0.5,
		opacity: 0,
		display: 'none',
        onComplete: function(){
        }
	});
});

$(document).ready(function(){
  var today = new Date($('.ziuareintalnirii-box').data('today'));
  $('.ziuareintalnirii-box').removeAttr('data-today')
  
function resizeBox() {
  //console.log(maxHeight);
  if ( $('.ziuareintalnirii-screen.active').outerHeight() > maxHeight ) {
    //console.log($('.ziuareintalnirii-screen.active').outerHeight());
    maxHeight = $('.ziuareintalnirii-screen.active').outerHeight();
    $('.ziuareintalnirii-box-content').css({'min-height':maxHeight+'px'});
  }
}

function showStore(store){

	$('#store-id').text(stores[store]);
	$('#buy-text').html(buyText[store]);
	$('#ziuareintalnirii-regulament').attr('href','https://bergenbier.ro/files/regulament-ziuareintalnirii-'+stores[store]);

	if (store == 2 || store == 6 ) {
		$('#store-id, .ziuareintalnirii-steps').addClass('snapped');
	}

	var startDate = startDates[store].split('/');
	var endDate = endDates[store].split('/');

	//console.log(new Date(endDate[2]+'-'+endDate[1]+'-'+endDate[0]+' 23:59:59'));
	//console.log(new Date() > new Date(endDate[2]+'-'+endDate[1]+'-'+endDate[0]));
  var endD = today; //'0d';
	if ( today > new Date(endDate[2]+'-'+endDate[1]+'-'+endDate[0]+' 23:59:59') ) {
		endD = endDates[store];
		$('#perioada').html('Campania s-a încheiat!<br>Vă invităm să participați la campaniile noastre viitoare!').show();
		$('#form-button').hide();
		$('#ziuareintalnirii-regulament').parent().show();
	} else if ( today >= new Date(startDate[2]+'-'+startDate[1]+'-'+startDate[0]) ) {
		$('#perioada').text('').hide();
		$('#form-button').show();
		$('#ziuareintalnirii-regulament').parent().show();
	} else {
		$('#ziuareintalnirii-regulament').parent().hide();
		$('#perioada').text('Campania se desfășoară în perioada '+messages[store]+' și va începe în curând.').show();
		$('#form-button').hide();
	}

	$('#prizes-desktop').attr('src','/themes/bergenbier/img/ziuareintalnirii/premii-desktop-'+store+'.png');
	$('#prizes-mobile').attr('src','/themes/bergenbier/img/ziuareintalnirii/premii-mobile-'+store+'.png');

	$('#zr-1').fadeOut(function(){
		$('#zr-store').fadeIn().addClass('active');
	}).removeClass('active');

	changePageTitle(pageTitles[1], stores[store]);

	$('.ziuareintalnirii-box-footer').addClass('active');

	$('.datepicker').datepicker('destroy').datepicker({
		language: 'ro',
		format: 'dd/mm/yyyy',
		maxViewMode: 1,
		autoclose: true,
		startDate: startDates[store],
		endDate: endD
	});

	resizeBox();

}

function changePageTitle(title, store){
	if (window.matchMedia("(max-width: 767px)").matches) {
		TweenMax.to($('#ziuareintalnirii-title'), 0.3, {opacity: 0, ease: Power2.easeOut, onComplete: function(){
			$('#ziuareintalnirii-title').html(title);
			if (store) {
				$('.ziuareintalnirii-box-header--logo').addClass('zr-logo-'+store).parent().parent().fadeIn();
			}
			TweenMax.fromTo($('#ziuareintalnirii-title'), 0.3, {ease: Power2.easeOut, opacity: 0}, {opacity: 1});
		}});
	} else {
		TweenMax.to($('#ziuareintalnirii-title'), 0.3, {y:'-100%', ease: Power2.easeOut, onComplete: function(){
			$('#ziuareintalnirii-title').html(title);
			if (store) {
				$('.ziuareintalnirii-box-header--logo').addClass('zr-logo-'+store).parent().parent().fadeIn();
			}
			TweenMax.fromTo($('#ziuareintalnirii-title'), 0.3, {ease: Power2.easeOut, y:'100%'}, {y:'0%'});
		}});
	}
}

function showForm(){
	document.getElementById("ziuareintalnirii-form").reset();

	changePageTitle(pageTitles[2]);

	$('.ziuareintalnirii-screen.active').fadeOut(function(){
		$('#zr-form').fadeIn().addClass('active');
		resizeBox();
	}).removeClass('active');


}

function showWinners(){

	var winnersList = new List('winners-list', {
      valueNames: ['name','city', 'date'],
      page: 5,
      pagination: true
    });

	changePageTitle(pageTitles[3]);

	$('.ziuareintalnirii-screen.active').fadeOut(function(){
		$('#zr-winners').fadeIn().addClass('active');
		resizeBox();
	}).removeClass('active');
}

function showStores(){
	document.getElementById("ziuareintalnirii-form").reset();
	$('.ziuareintalnirii-screen.active').fadeOut(function(){
		$('#store-id, .ziuareintalnirii-steps').removeClass('snapped');
		$('#zr-1').fadeIn().addClass('active');
		resizeBox();
	}).removeClass('active');

	changePageTitle(pageTitles[0]);

	$('.ziuareintalnirii-box-header--holder').fadeOut(function(){
		$('.ziuareintalnirii-box-header--logo').attr('class','ziuareintalnirii-box-header--logo');
	});
	$('.ziuareintalnirii-box-footer').removeClass('active');
}

function showStoreHome(){
	if ( !$('#zr-store').hasClass('active') ) {

		document.getElementById("ziuareintalnirii-form").reset();

		$('.ziuareintalnirii-screen.active').fadeOut(function(){
			$('#zr-store').fadeIn().addClass('active');
			resizeBox();
		}).removeClass('active');

		changePageTitle(pageTitles[1]);
	}
}

	$('.ziuareintalnirii-magazine a').on('click', function(e){
		e.preventDefault();
		activeStore = $(this).data('store');
		showStore(activeStore);
	});

	$('#showForm,#resetForm').on('click', function(e){
		e.preventDefault();
		showForm();
	});

	$('#showWinners').on('click', function(e){
		e.preventDefault();
		showWinners();
	});

	$('#showStores').on('click', function(e){
		e.preventDefault();
		showStores();
	});

	$('#showStoreHome').on('click', function(e){
		e.preventDefault();
		showStoreHome();
	});

	$("form.ziuareintalnirii-form").on('submit', function(e){
		e.preventDefault();
		if($(this).data('submitting'))
			return false; //double submit

		$('.form-group', this).removeClass('has-error');
		$('.form-group span.help-block', this).remove();
		$(this).data('submitting', true).addClass('submitting');
		$('button[type=submit]', this).button('loading');
		// $('button[type=submit] span.submit-label', this).text('Se trimite...');
    
    $('input[name=store_id]', this).val(activeStore);
    var acum = window.location.search.replace(/^\?acum=/, "&acum="); //dev only
		$.ajax({
			type: $(this).attr('method'),
			url: $(this).attr('action'),
			data: $(this).serialize() + acum,
			context: this,
	//			dataType: 'json',
			success: function(data){
				console.log("succ:", data);
				 if (window.ga) {
				 	ga('send', 'pageview', '/ziuareintalnirii/'+stores[activeStore]+'/succes');
				 }

				 /* window.dataLayer = window.dataLayer || [];
				  window.dataLayer.push({
					  'event': 'SMS2020Success'
				  });*/
				document.getElementById("ziuareintalnirii-form").reset();
				$('.ziuareintalnirii-message').html(data.message);

				changePageTitle(pageTitles[4]);

				$('.ziuareintalnirii-screen.active').fadeOut(function(){
					$('#zr-message').fadeIn().addClass('active');
					resizeBox();
				}).removeClass('active');
			},
			error: function(xhr) {
				$('button[type=submit] span.submit-label', this).text('Trimite');
				if(xhr.status == 422) {
          var errors  = xhr.responseJSON.errors || xhr.responseJSON || [];
          for (var field in errors) {
            // console.log(field);
            $('*[name=' + field + '], input[name=' + field + ']+label', this)
                .parents('.form-group:first').addClass('has-error')
                .append(
                    function () {
                      $errors = "";
                      for (var err in errors[field])
                        $errors += '<span class="help-block">' + errors[field][err] + '</span>';
                      return $errors;
                    }
                );
          }
				} else if(xhr.status == 403) {
					console.log(xhr);
				}
			},
			complete: function(xhr) {
				$(this).data('submitting', false).removeClass('submitting');
				$('button[type=submit]',this).button('reset');
			}
		});
	});

});
